// Configuration for lazysizes
window.lazySizesConfig = window.lazySizesConfig || {};

// Makes sure that off-screen images are downloaded after window onload event
window.lazySizesConfig.preloadAfterLoad = true;
